import * as yup from "yup";

import { Button, Grid } from "@mui/material";
import {
  EnhancedDialog,
  EnhancedSnackbarAlert,
  ITest,
  RHookFormPasswordFieldWithLabel,
  SubmitButton,
} from "@websential/cosmic";
import { FormProvider, useForm } from "react-hook-form";
import React, { FC, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { AxiosResponse } from "axios";
import { IAppState } from "../../../../store/reducers";
import http from "../../../../common/http-common";
import { setSelectedDashboardApisData } from "../../../../store/actions/dashboardApisDataActions";
import { useNavigate } from "react-router-dom";
import { yupResolver } from "@hookform/resolvers/yup";

// import http from "../../common/http-common";
// import { EnhancedDialog } from "../EnhancedDialog";
// import { EnhancedSnackbar } from "../EnhancedSnackbar";
// import { ITest } from "../../interfaces";
// import { RHookFormPasswordFieldWithLabel } from "../RHookFormPasswordFieldWithLabel";
// import { SubmitButton } from "../SubmitButton";
// import { EnhancedSnackbarAlert } from "../EnhancedSnackbarAlert";

export interface IMaskUnmask extends ITest {
  /**
   * If true, component will show loading state.
   */
  PostApiUrl: string;
  /**
   * for mask data when user click button with text 'Mask'.
   */
  PutApiUrl: string;
  /**
   * If true, component will show error state.
   */
  UnsetMaskFlagTimeoutInMinutes: number;

  homePathRoute: string;
}

export interface IPostPayload {
  password: string;
}

export interface IServerError {
  status: boolean;
  message: string;
  error: boolean;
}

export interface IResponse {
  status: boolean;
  message: string;
}
export interface IResponseTimeOut {
  status: boolean;
  masked_status: boolean;
  message: string;
}

export const ApiService = {
  verify: async (
    data: IPostPayload,
    url: string
  ): Promise<IPostPayload | IServerError | IResponse> => {
    const response: AxiosResponse<IPostPayload> = await http.post<IPostPayload>(
      url,
      data
    );
    if (response.status === 200) return response.data;
    else if (response.status === 400) return response.data;
    return {
      status: false,
      message: "Something went wrong please try again later.",
      error: true,
    };
  },
  verifyTimeLimit: async (
    // data: IPostPayload,
    url: string
  ): Promise<IPostPayload | IServerError | IResponse> => {
    const response: AxiosResponse<IPostPayload> = await http.put<IPostPayload>(
      url
      // data
    );
    if (response.status === 200) return response.data;
    else if (response.status === 400) return response.data;
    return {
      status: false,
      message: "Something went wrong please try again later.",
      error: true,
    };
  },
};

export const MaskUnmask: FC<IMaskUnmask> = ({
  PostApiUrl,
  PutApiUrl,
  UnsetMaskFlagTimeoutInMinutes,
  homePathRoute,
  testId,
}) => {
  const dispatch = useDispatch()
  const schema = yup.object().shape({
    password: yup
      .string()
      .required("Password is required.")
      .min(8, "Invalid password.")
      .max(100, "Invalid password."),
  });

  const methods = useForm({
    resolver: yupResolver(schema),
  });

  const navigate = useNavigate();
  const [isLoading, setLoading] = React.useState<boolean>(false);
  const dashboardApiData = useSelector((state: IAppState) => state.dashboardApisData)
  const [isError, setError] = React.useState<boolean>(false);
  const [showMessage, setShowMessage] = React.useState<boolean>(false);
  const [message, setMessage] = React.useState<string>("");

  const [open, setOpen] = React.useState(false);

  const [buttonLabel, setButtonLabel] = React.useState<string>("");

  const fetchApiDataAsync = async (data: IPostPayload): Promise<void> => {
    try {
      setLoading(true);
      const response = await ApiService.verify(data, PostApiUrl);
      const responseData = response as IResponse | IResponseTimeOut;
      const responseError = response as IServerError;

      if (responseError.error) {
        setMessage(responseError.message);
        setError(true);
      } else {
        // console.log('responseData',responseData)
        if (responseData.status) {
          setButtonLabel("Mask");
          dispatch(setSelectedDashboardApisData({ masked_status: false }));
          window.sessionStorage.setItem("maskEnabled", "false");
          const unmaskTime = new Date();
          window.sessionStorage.setItem("unmaskTime", unmaskTime.toString());
          setMessage(
            "Success, data will remain unmasked for next " +
            UnsetMaskFlagTimeoutInMinutes +
            " minutes"
          );
          setError(false);
          setOpen(false);
          setLoading(false);
          methods.reset();
          // navigate(homePathRoute);
          setTimeout(()=>{
            window.location.reload()
          },1000)
        } else {
          // console.log('dfbdbf')
          dispatch(setSelectedDashboardApisData({ masked_status: true }));
          window.sessionStorage.setItem("maskEnabled", "true");
          setButtonLabel("Unmask");
          setError(true);
          setMessage(responseData.message);
        }
        setShowMessage(true);
      }
      setLoading(false);
    } catch (err) {
      setError(true);
      setMessage("Something went wrong please try again later.");
      setLoading(false);
    }
  };
  const fetchApiDataAsyncTimeOut = async (): Promise<void> => {

    try {
      setLoading(true);
      const response = await ApiService.verifyTimeLimit(PutApiUrl);
      const responseData = response as IResponseTimeOut;
      const responseError = response as IServerError;


      if (responseError.error) {
        setMessage(responseError.message);
        setError(true);
      } else {
        if (responseData.status) {
          setButtonLabel("UnMask");
          dispatch(setSelectedDashboardApisData({ masked_status: true }));
          window.sessionStorage.setItem("maskEnabled", "true");
          // const unmaskTime = new Date();
          // window.sessionStorage.setItem("unmaskTime", unmaskTime.toString());
          setMessage(responseData.message);
          // navigate(homePathRoute);
          window.location.reload()
        }
      }
    } catch (err) {
      setError(true);
      setMessage("Something went wrong please try again later.");
      setLoading(false);
    }
  };

  var add_minutes = function (dt: any, minutes: any) {
    return new Date(dt.getTime() + minutes * 60000);
  };

  useEffect(() => {
    // // Get saved maskEnabled from sessionStorage
    // let maskEnabledStorage = sessionStorage.getItem("maskEnabled") || "";
    // // Set the storage key in case key does not exist in session
    // window.sessionStorage.setItem("maskEnabled", maskEnabledStorage);

    // if (maskEnabledStorage !== "" && maskEnabledStorage === "false") {
    //   setButtonLabel("Mask");
    // } else {
    //   setButtonLabel("Unmask");
    // }
    if (dashboardApiData.masked_status === false) {
      setButtonLabel("Mask");
    } else {
      setButtonLabel("Unmask");
    }

    const interval = setInterval(() => {
      const unmaskedTime = window.sessionStorage.getItem("unmaskTime");
      if (unmaskedTime) {
        const maskedTime = add_minutes(
          new Date(unmaskedTime),
          UnsetMaskFlagTimeoutInMinutes
        );
        if (new Date() > new Date(maskedTime)) {
          dispatch(setSelectedDashboardApisData({ masked_status: true }));
          window.sessionStorage.setItem("maskEnabled", "true");
          sessionStorage.removeItem("unmaskTime");
          setButtonLabel("Unmask");
          fetchApiDataAsyncTimeOut();
          // navigate(homePathRoute);
          setTimeout(()=>{
            window.location.reload()
          },1000)
        }
      }
    }, 1000 * 30); // its half 30 second interval
    return () => clearInterval(interval);
  }, [dashboardApiData]);

  const onSubmit = (data: any) => {
    setLoading(true);
    if (buttonLabel === "Unmask") {
      fetchApiDataAsync(data);
    }
  };

  const handleClose = (_event?: React.SyntheticEvent, _reason?: string) => {
    setMessage("");
    setShowMessage(false);
  };

  const onOpenHandler = () => {
    methods.reset();
    if (buttonLabel === "Unmask") {
      setOpen(true);
    } else {
      window.sessionStorage.setItem("maskEnabled", "true");
      dispatch(setSelectedDashboardApisData({ masked_status: true }));
      setButtonLabel("Unmask");
      sessionStorage.removeItem("unmaskTime");
    }
    if (buttonLabel === "Mask") {
      fetchApiDataAsyncTimeOut();
    }
  };

  const onCloseHandler = () => {
    setOpen(false);
    setMessage("");
    setShowMessage(false);
    methods.reset();
  };

  return (
    <Grid data-testid={testId}>
      {showMessage && (
        <EnhancedSnackbarAlert
          showMessage={showMessage}
          isError={isError}
          message={message}
          autoHideDuration={5000}
          handleClose={handleClose}
        />
      )}
      <Button
        color="primary"
        data-testid={"mask-unmask-button"}
        onClick={onOpenHandler}
        variant="contained"
        style={{
          textTransform: "capitalize",
        }}
      >
        {buttonLabel}
      </Button>
      <FormProvider {...methods}>
        <form onSubmit={methods.handleSubmit(onSubmit)}>
          <EnhancedDialog
            dialogTitle="Verify your password to unmask data"
            key="dialog-box"
            testId="dialog"
            onCloseHandler={onCloseHandler}
            open={open}
            dialogContent={
              <RHookFormPasswordFieldWithLabel
                id="password"
                testId="password"
                label="Password"
                placeholder="Please enter your password"
                required={true}
              />
            }
            dialogAction={
              <SubmitButton
                label="Verify"
                testId="Verify"
                loading={isLoading}
                onClickHandler={methods.handleSubmit(onSubmit)}
              />
            }
          />
        </form>
      </FormProvider>
    </Grid>
  );
};
